const $paymentHintClose = document.querySelector('.payment-hint__close');

if ($paymentHintClose) {
    $paymentHintClose.addEventListener('click', () => {
        document.querySelector('.payment-hint').remove();
    })
}